export default {
  id: "gaokao-aftermath",
  pride: 38912,
  slug: "gaokao-aftermath",
  series: "gaokao",
  category: ["video", "blog"],
  status: "released",
  experienceable: true,
  titleKey: {
    zh: "高考后日谈：16个人生终极拷问",
    en: "Post-Gaokao Talks: 16 Ultimate Life Questions"
  },
  bilibiliVideoId: "BV1N9ThzAEXP",
  descriptionKey: {
    zh: "高考结束后这90天是人生最重要的战略留白期。16个世界不教但你需要知道的问题。",
    en: "The 90 days after Gaokao are your most important strategic blank space. 16 questions the world won't teach you but you need to know."
  },
  date: { year: 2025, month: 6, day: 9 },
  genres: ["人生规划", "高考后"],
  themes: ["成长", "人生选择", "迷茫"],
  developerNotesKey: {
    zh: "嘿，刚刚解放的你，恭喜通关了高中时代！高考后的这90天，可能是你人生中最重要的一段「战略留白期」。迷茫、焦虑、空虚、选择困难……我整理了16个问题。让我们一起聊聊这些世界不教，但你也许需要知道的事。时间有些长，最好准备些茶水点心。",
    en: "Hey, newly liberated one — congratulations on clearing the high school era! The 90 days after Gaokao may be the most important 'strategic blank period' of your life. Confusion, anxiety, emptiness, decision paralysis... I've compiled 16 questions. Let's talk about things the world doesn't teach you but you might need to know. It's a bit long — best prepare some tea and snacks."
  },
  tags: ["VRChat", "高考"],
  longDescriptionKey: {
    zh: "",
    en: ""
  },
  links: [
    { type: "bilibili", url: "https://www.bilibili.com/video/BV1N9ThzAEXP/", textKey: { zh: "B站观看", en: "Watch on Bilibili" } }
  ]
};
